import { Component, EventEmitter, Input, OnChanges, OnInit, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Loan, LoanPayout } from 'taxtank-core';
import { plainToClass } from 'class-transformer';

/**
 * Add new / update Payout loan form
 */
@Component({
  selector: 'app-loan-payout-form',
  templateUrl: './loan-payout-form.component.html',
  styleUrls: ['./loan-payout-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoanPayoutFormComponent implements OnInit, OnChanges {
  private fb = inject(UntypedFormBuilder);

  @Input() loan: Loan;
  @Input() taxTankBalance: number;
  @Output() submitted: EventEmitter<LoanPayout> = new EventEmitter<LoanPayout>();
  form: UntypedFormGroup;
  interestBalance: number;

  

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnChanges(): void {
    this.calculateInterestBalance();
  }

  /**
   * Build loan pay out form
   */
  buildForm(): void {
    this.form = this.fb.group({
      // @Todo remove 'toFixed()' hack and use class-transformer when it will be implemented
      currentLoanBalance: [{ value: this.taxTankBalance.toFixed(2), disabled: true }],
      interestBalance: [{ value: this.interestBalance, disabled: true }],
      payoutAmount: [this.loan.payout?.payoutAmount || Math.abs(this.loan.currentBalance), Validators.required],
      date: [this.loan.payout?.date || new Date(), Validators.required],
      fees: [{ value: null, disabled: true }]
    });

    this.recalculateFees(this.form.get('payoutAmount').value);

    // subscribe for payoutAmount form field changes
    this.form.get('payoutAmount').valueChanges.subscribe((payoutAmount: number) => {
      this.recalculateFees(payoutAmount);
    });
  }

  /**
   * Calculate interest balance amount
   */
  calculateInterestBalance(): void {
    const now: Date = new Date();

    for (const payment of this.loan.payments) {
      this.interestBalance = payment.interestBalance;

      if (new Date(payment.date) > now) {
        break;
      }
    }
  }

  /**
   * Recalculate fees
   * @param payoutAmount
   */
  recalculateFees(payoutAmount: number): void {
    this.form.get('fees')
      .setValue(this.taxTankBalance - payoutAmount > 0 ? this.taxTankBalance - payoutAmount : 0);
  }

  /**
   * Submit form and pay out/update payout loan
   */
  submit(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    this.submitted
      .emit(Object.assign(plainToClass(LoanPayout, {} as LoanPayout), this.loan.payout, this.form.getRawValue()));
  }
}
